<div class="page-header-container">
  <h1 class="page-header-title">{{ 'SLAUGHTERHOUSE.BYPRODUCTS_AND_FILLSPOTS' | translate }}</h1>
  <mat-divider></mat-divider>
  <div class="grid">
    @for (item of slaughterhouseItem()?.byproducts; track $index) {
      <div class="grid-item">
        <md-info-block [title]="'FIELDS.PRODUCT' | translate" [text]="item.productName.fi"></md-info-block>
        <md-info-block [title]="'FIELDS.CODE' | translate" [text]="item.productId"></md-info-block>
        <md-info-block [title]="'FIELDS.FILLING_SPOT' | translate" [text]="item.fillingSpotId"></md-info-block>
      </div>
    }
  </div>
</div>
